import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useAuth } from "../lib/authContext";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export default function AccountVerify() {
  const nav = useNavigate();
  const { reload } = useAuth();
  const [code, setCode] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const email = sessionStorage.getItem("aiude_account_email") || "";

  const submit = async (e) => {
    e.preventDefault();
    if (!email) { toast.error("Please start again from the sign-in page."); nav("/account/sign-in"); return; }
    setSubmitting(true);
    try {
      await axios.post(API + "/account/otp/verify", { email, code }, { withCredentials: true });
      sessionStorage.removeItem("aiude_account_email");
      await reload();
      toast.success("Signed in.");
      nav("/control-center");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid or expired code");
    } finally { setSubmitting(false); }
  };

  return (
    <div className="max-w-lg mx-auto py-10 lg:py-16" data-testid="account-verify-page">
      <div className="font-tech text-xs text-slate-400 mb-2">SIGN-IN CODE</div>
      <h1 className="text-3xl sm:text-4xl font-bold text-white mb-3">Enter your code</h1>
      <p className="text-slate-400 text-sm mb-6">We emailed a six-digit code {email ? "to " + email : ""}. It expires in 15 minutes.</p>
      <form onSubmit={submit} className="panel-elev p-6 space-y-4">
        <input inputMode="numeric" required maxLength={6} pattern="\d{6}" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
          placeholder="123456"
          className="w-full bg-slate-900 border border-slate-700 rounded px-3 py-2 text-white text-center tracking-[0.5em] text-xl font-mono"
          data-testid="account-verify-code" />
        <button type="submit" disabled={submitting || code.length !== 6}
          className="w-full py-2.5 bg-[#00D2FF] text-slate-900 font-semibold rounded disabled:opacity-50"
          data-testid="account-verify-submit">
          {submitting ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
